import OwnerModel from '../owner/owner-model';
import UserModel from '../user/user-model';

export default class MenuModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    path: string;
    icon: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        this.path = datarow.path;
        this.icon = datarow.icon?.split(';')?.[1] || datarow.icon;
    } 

    public static endPoint: string = 'menus' 
    public static endPointFilterList = () => {
        const owner = OwnerModel.getOwner();
        
        return ( '?populate=*&sort=id &filters[owner]=' + owner);
    }
    public static endPointFilterList2 = (menugroupId?: number ) => {
        const owner = OwnerModel.getOwner();
        const user = UserModel.getUser();

        return ( '?populate=*&sort=id&filters[status]=active' + (menugroupId ===  1? '&filters[menugroup][id]=1' : '&filters[menugroup][accessowner][id]=' + owner + '&filters[menugroup][user][id]=' + user + (menugroupId? '&filters[$or][0][menugroup][id]=' + menugroupId : '')));
    } 
    public static url: string = '/menu';
    public static caption: string = 'Menu';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),   
        path: '',
        icon: 'view_comfy',
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
        { name: 'path', required: true },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static columnPicklistCard = [
        { name: 'icon', type: 'icon' },
        { name: 'name', type: 'caption' },
        { name: 'description'},
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
}